import { createSlice } from '@reduxjs/toolkit';

const restaurantSlice = createSlice({
    name: 'restaurant',
    initialState: {
        bookTableOption: {
            selectedPeople: null,
            selectedDate: null,
            selectedTime: null,
        },
        conCheckItems: {
            typeArr: [],
            tagArr: []
        }
    },
    reducers: {
        setBookTableOption: (state, action) => {
            state.bookTableOption = action.payload;
        },
        resetBookTableOption: (state) => {
            state.bookTableOption = {
                selectedPeople: null,
                selectedDate: null,
                selectedTime: null,
            };
        },
        setConditionBar: (state, action) => {
            state.conCheckItems = action.payload;
        },
        resetConditionBar: (state) => {
            state.conCheckItems = {
                typeArr: [],
                tagArr: []
            };
        }
    },
});

export const { setBookTableOption, resetBookTableOption, setConditionBar, resetConditionBar } = restaurantSlice.actions;
export const selectBookTableOption = (state) => state.restaurant.bookTableOption;
export const selectConCheckItems = (state) => state.restaurant.conCheckItems;
export default restaurantSlice.reducer;